import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ClearEjecucionIncidencia, sendEjecucionIncidencia } from '../../../../store/actions/ejecucion.actions';
import { AppState } from '../../../../store/app-reducers';
import { SendEjecucionInciState } from '../../../../store/reducers/ejecucion.reducer';
import { IEjecucionIncidencia } from '../../models/task-ejecucion';
import { TransferDataService } from '../../services/transfer-data.service';

@Component({
  selector: 'incidencia-ejecucion',
  templateUrl: './incidencia-ejecucion.component.html',
  styleUrls: ['./incidencia-ejecucion.component.scss'],
})
export class IncidenciaEjecucionComponent implements OnInit, OnDestroy {

  @Input() incidencia: IEjecucionIncidencia = { Activo: false } as IEjecucionIncidencia;
  @Output() ionFocus = new EventEmitter<CustomEvent | MouseEvent>();

  public isSpinner = false
  public formulario: UntypedFormGroup

  private finishSubscriptions: Subject<boolean> = new Subject();

  constructor(
    private transferDataS: TransferDataService
    , private formBuilder: UntypedFormBuilder
    , private store: Store<AppState>
  ) { }

  ngOnInit() {
    this.initializeForm();

    this.store.select('ejecucionInci')
      .pipe(takeUntil(this.finishSubscriptions))
      .subscribe(this.callbackEjecucionInci);
  }

  ngOnDestroy() {
    this.finishSubscriptions.next(true);
    this.finishSubscriptions.complete();
    this.store.dispatch(ClearEjecucionIncidencia());
    this.transferDataS.alertDismiss()
  }

  private initializeForm = () => {
    this.formulario = this.formBuilder.group({
      comentario: [
        ''
        , [
          Validators.required
          , Validators.minLength(this.incidencia.CaracterMinimo || 0)
          , Validators.maxLength(this.incidencia.CaracterMaximo || 0)
        ]
      ]
    })
  }

  public onSubmit = () => {
    this.formulario.get('comentario')?.setValue(this.formulario.get('comentario')?.value.toString().trim());
    if (this.formulario.invalid) { return; }

    const objectSend = {
      ID_EjecucionIncidencias: this.incidencia.ID_EjecucionIncidencias || 0
      , Incidencia: this.formulario.get('comentario')?.value || ''
    }

    this.store.dispatch(sendEjecucionIncidencia(objectSend));
  }

  private callbackEjecucionInci = (resp: SendEjecucionInciState) => {
    this.isSpinner = resp.loading;
    if (resp.success) {
      this.formulario.controls['comentario'].setValue('');
      this.transferDataS.presentAlert(resp.status);
    }

    if (resp.error) {
      this.transferDataS.presentAlert(this.incidencia.ErrorSend || '');
    }
  }

}
